import React from 'react';

export default function Carousel({ children }) {
    const [curIndex, setCurIndex] = React.useState(0);
    const findListIndex = (idx) => {
        return ((idx % children.length) + children.length) % children.length;
    };
    return (
        <div className={'carousel'}>
            <button
                className={'carousel-items-prevbutton'}
                onClick={() => setCurIndex(findListIndex(curIndex - 1))}
                aria-label={"Show previous teacher quote"}
            >
                <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.3318 19.4685C11.66 19.7228 12.0291 19.85 12.4393 19.85C12.71 19.85 12.9561 19.7966 13.1775 19.69C13.4811 19.5587 13.723 19.3619 13.9035 19.0994C14.084 18.8369 14.1742 18.5498 14.1742 18.238V13.55H22.0492C22.9188 13.55 23.6611 13.2423 24.2764 12.6271C24.8916 12.0119 25.1992 11.2695 25.1992 10.4C25.1992 9.53042 24.8916 8.79214 24.2764 8.18511C23.6611 7.57808 22.9188 7.27456 22.0492 7.27456H14.1742V2.58647C14.1742 2.26655 14.084 1.97534 13.9035 1.71284C13.723 1.44214 13.4811 1.24116 13.1775 1.10991C12.9561 1.00327 12.71 0.949951 12.4393 0.949951C12.0291 0.949951 11.66 1.0771 11.3318 1.3314L0.626759 9.15718C0.208399 9.4689 -0.000778198 9.88315 -0.000778198 10.4C-0.000778198 10.9167 0.208399 11.331 0.626759 11.6427L11.3318 19.4685Z" fill="#3804C1"/>
                </svg>

            </button>
            <div className={'carousel-items'}>
                {children[curIndex]}
            </div>
            <button
                className={'carousel-items-nextbutton'}
                onClick={() => setCurIndex(findListIndex(curIndex + 1))}
                aria-label={"Show next teacher quote"}
            >
                <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.6682 19.4685C14.34 19.7228 13.9709 19.85 13.5607 19.85C13.29 19.85 13.0439 19.7966 12.8225 19.69C12.5189 19.5587 12.277 19.3619 12.0965 19.0994C11.916 18.8369 11.8258 18.5498 11.8258 18.238V13.55H3.95078C3.08125 13.55 2.33887 13.2423 1.72363 12.6271C1.1084 12.0119 0.800781 11.2695 0.800781 10.4C0.800781 9.53042 1.1084 8.79214 1.72363 8.18511C2.33887 7.57808 3.08125 7.27456 3.95078 7.27456H11.8258V2.58647C11.8258 2.26655 11.916 1.97534 12.0965 1.71284C12.277 1.44214 12.5189 1.24116 12.8225 1.10991C13.0439 1.00327 13.29 0.949951 13.5607 0.949951C13.9709 0.949951 14.34 1.0771 14.6682 1.3314L25.3732 9.15718C25.7916 9.4689 26.0008 9.88315 26.0008 10.4C26.0008 10.9167 25.7916 11.331 25.3732 11.6427L14.6682 19.4685Z" fill="#3804C1"/>
                </svg>
            </button>
            <div className={'carousel-pips'}>
                {children.map((item, idx) => (
                    <div
                        key={idx}
                        className={idx == curIndex ? 'carousel-pip-selected' : ''}
                        onClick={() => setCurIndex(idx)}
                        tabIndex={0}
                    />
                ))}
            </div>
        </div>
    )
}
